import axios from 'axios'
import {
  BoardActivityStatusEnum,
  IBoardActivityUpdateModel,
} from '../models/Comments'
const BASE_URL_CASE = 'boardmeetings/cases'
const BASE_URL_MEETING = 'boardmeetings/meetings'
const defaultConfig = {
  headers: {
    'x-api-version': '1.0',
  },
}

export const getCaseComments = (caseId: string) =>
  axios.get(`${BASE_URL_CASE}/${caseId}/comments`, defaultConfig)

export const editBoardComment = (
  model: IBoardActivityUpdateModel,
  body: { text: string }
) =>
  axios.put(
    `${
      model.type === BoardActivityStatusEnum.Case
        ? BASE_URL_CASE
        : BASE_URL_MEETING
    }/${model.id}/comments/${model.commentId}`,
    body,
    defaultConfig
  )

export const createBoardComment = (
  model: IBoardActivityUpdateModel,
  body: { text: string }
) =>
  axios.post(
    `${
      model.type === BoardActivityStatusEnum.Case
        ? BASE_URL_CASE
        : BASE_URL_MEETING
    }/${model.id}/comments`,
    body,
    defaultConfig
  )

export const deleteBoardComment = (model: IBoardActivityUpdateModel) =>
  axios.delete(
    `${
      model.type === BoardActivityStatusEnum.Case
        ? BASE_URL_CASE
        : BASE_URL_MEETING
    }/${model.id}/comments/${model.commentId}`,
    defaultConfig
  )

export const getMeetingComments = (meetingId: string) =>
  axios.get(`${BASE_URL_MEETING}/${meetingId}/comments`, defaultConfig)
